module.exports = __webpack_public_path__ + "media/6.6fa0dd35.mp3";